import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import rdsLogo from "../images/rds-logo.png";
import blossomsLogo from "../images/blossoms-logo-2.png";
import { motion } from "framer-motion";
// data
import { AppConstants } from "../data/appConstants";

const NavbarItemList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const StyledNavLink = styled(NavHashLink)`
  margin: 1rem 0;
  padding: 0;
  width: 8vw;
  /* display: block; */
  text-decoration: none;
  color: rgb(255, 255, 255);
  font-size: 1vw; // 1rem
`;

const StyledMotionP = styled(motion.p)`
  font-family: "HelveticaNeueBold";
`;

const Logo = styled.img`
  height: auto;
  max-width: 200px;
  max-height: 200px;
  min-height: 100px;
  margin: 0;
  padding: 1rem;
  align-self: center;
  object-fit: contain;
`;

function Navbar() {
  return (
    <Grid
      style={{ position: "absolute", zIndex: 100 }}
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={0}
    >
      <Grid item xs={6} sm={2} style={{ display: "flex" }}>
        <NavLink to="/">
          <Logo src={rdsLogo} style={{ width: "10vw" }} />
        </NavLink>
        <NavLink to="/">
          <Logo src={blossomsLogo} style={{ width: "6vw" }} />
        </NavLink>
      </Grid>
      <Grid item xs={false} sm={1}></Grid>
      <Grid item xs={false} sm={8}>
        <NavbarItemList>
          {AppConstants.navbar.nav_items.map((navItem) => (
            <StyledNavLink to={navItem.link_to} key={navItem.id}>
              <StyledMotionP
                whileHover={{
                  color: "rgba(0,188,228,1)",
                  transition: { duration: 1 },
                }}
              >
                {navItem.title_en}
              </StyledMotionP>
            </StyledNavLink>
          ))}
          <Grid item xs={false} sm={1}></Grid>
        </NavbarItemList>
      </Grid>
    </Grid>
  );
}

export default Navbar;
